import React, { Component } from "react";
import FieldList from "components/attribute/FieldList";
import NavigationFooter from "components/footers/NavigationFooter";
class Studies extends Component {
  render() {
    return (
      <>
        <div className="regular-padding">
          <h1 style={{ marginBottom: 0 }}>
            Select at least one area of tertiary study{" "}
          </h1>
          <h1 style={{ fontWeight: 400 }}>to see recommended HSC subjects</h1>

          <p className="title">
            Your selections match these general areas of tertiary study
          </p>
          <em>Ordered according to closeness of match</em>
          <FieldList />
        </div>
        <NavigationFooter studies={true} />
      </>
    );
  }
}

export default Studies;
